export default "__VITE_ASSET__zXe7lp23__"